import React from "react";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";
import icon1 from "../../assest/footericon.svg";
import icon2 from "../../assest/footericon2.svg";
import footerlogo from "../../assest/rasutrip.png";
import { Link, useNavigate, useLocation } from "react-router-dom";

const QUICK_LINKS = [
  { to: "/Aboutus", label: "About Us" },
  { to: "/faq", label: "FAQ" },
  { to: "/Blogs", label: "Blog" },
  { to: "/Offers", label: "Offers" },
];

const LEGAL_LINKS = [
  { to: "/terms-and-conditions", label: "Terms & Conditions" },
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/disclaimer", label: "Disclaimer" },
  { to: "/UserAgreement", label: "User Agreement" },
  { to: "/CancellationRefundpolicy", label: "Refund Policy" },
];

const SOCIALS = [
  { icon: FaFacebookF, href: "https://www.facebook.com/people/RasuTrip-Flight-Bus-Hotel-Booking-Platform/61579934815097/#", label: "Facebook" },
  { icon: FaInstagram, href: "https://www.instagram.com/rasutrip/", label: "Instagram" },
  { icon: FaLinkedinIn, href: "https://www.linkedin.com/company/rasutrip-websoft-technologies-llp/?viewAsMember=true", label: "LinkedIn" },
  { icon: FaYoutube, href: "https://youtube.com/@rasutrip", label: "YouTube" },
];

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleTabNavigation = (tabType) => {
    if (location.pathname === "/") {
      document.querySelector(".slider-container")?.scrollIntoView({ behavior: "smooth" });
      window.dispatchEvent(new CustomEvent("setActiveTab", { detail: { tabType } }));
    } else {
      navigate(`/?tab=${tabType}`);
    }
  };

  return (
    <footer className="bg-ink-900 text-ink-300">
      <div className="max-w-[1280px] mx-auto px-6 py-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-10">
        {/* Brand + app */}
        <div className="col-span-2">
          <img src={footerlogo} alt="Rasu" className="h-11 w-auto rounded-lg mb-4" />
          <p className="text-sm leading-relaxed text-ink-400 max-w-xs mb-6">
            Your trusted travel companion for flights, hotels, and bus bookings across India.
          </p>
          <p className="text-xs font-bold tracking-wider text-ink-500 uppercase mb-3">Get the App</p>
          <div className="flex items-center gap-3 flex-wrap">
            <a href="https://apps.apple.com/app/rasutrip-bus-flight-hotel/id6753738292" target="_blank" rel="noopener noreferrer" className="opacity-90 hover:opacity-100 transition">
              <img src={icon1} alt="Download on App Store" className="h-10 w-auto" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.om.rasutrip&pcampaignid=web_share" target="_blank" rel="noopener noreferrer" className="opacity-90 hover:opacity-100 transition">
              <img src={icon2} alt="Get it on Google Play" className="h-10 w-auto" />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h5 className="text-white text-sm font-bold mb-4">Quick Links</h5>
          <ul className="space-y-2.5">
            {QUICK_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm text-ink-400 hover:text-white transition">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div>
          <h5 className="text-white text-sm font-bold mb-4">Our Services</h5>
          <ul className="space-y-2.5">
            <li>
              <button onClick={() => handleTabNavigation("flight")} className="text-sm text-ink-400 hover:text-white transition text-left">
                Flight Booking
              </button>
            </li>
            <li>
              <button onClick={() => handleTabNavigation("hotel")} className="text-sm text-ink-400 hover:text-white transition text-left">
                Hotel Booking
              </button>
            </li>
            <li>
              <button onClick={() => handleTabNavigation("bus")} className="text-sm text-ink-400 hover:text-white transition text-left">
                Bus Booking
              </button>
            </li>
            <li>
              <Link to="/login/agent" className="text-sm text-ink-400 hover:text-white transition">
                Become an Agent
              </Link>
            </li>
            <li>
              <Link to="/partner/register" className="text-sm text-ink-400 hover:text-white transition">
                Become a Travel Partner
              </Link>
            </li>
          </ul>
        </div>

        {/* Legal */}
        <div>
          <h5 className="text-white text-sm font-bold mb-4">Legal</h5>
          <ul className="space-y-2.5">
            {LEGAL_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm text-ink-400 hover:text-white transition">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Contact strip */}
      <div className="border-t border-white/10">
        <div className="max-w-[1280px] mx-auto px-6 py-10 grid sm:grid-cols-3 gap-6">
          <div className="flex items-start gap-3">
            <div className="h-9 w-9 rounded-lg bg-white/5 flex items-center justify-center shrink-0">
              <FaPhoneAlt className="text-brand-400" size={14} />
            </div>
            <div>
              <div className="text-xs text-ink-500 mb-0.5">24/7 Customer Support</div>
              <a href="tel:+919266424809" className="text-sm font-semibold text-white hover:text-brand-400 transition">
                +91 9266424809
              </a>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <div className="h-9 w-9 rounded-lg bg-white/5 flex items-center justify-center shrink-0">
              <FaEnvelope className="text-brand-400" size={14} />
            </div>
            <div>
              <div className="text-xs text-ink-500 mb-0.5">Email Support</div>
              <a href="mailto:support@rasutrip.com" className="text-sm font-semibold text-white hover:text-brand-400 transition">
                support@rasutrip.com
              </a>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <div className="h-9 w-9 rounded-lg bg-white/5 flex items-center justify-center shrink-0">
              <FaMapMarkerAlt className="text-brand-400" size={14} />
            </div>
            <div>
              <div className="text-xs text-ink-500 mb-0.5">Head Office</div>
              <div className="text-sm font-semibold text-white">
                Sarfabad, Noida, Gautam Buddha Nagar, UP – 201307
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom strip */}
      <div className="border-t border-white/10">
        <div className="max-w-[1280px] mx-auto px-6 py-6 flex flex-wrap items-center justify-between gap-4">
          <p className="text-xs text-ink-500">
            © {new Date().getFullYear()} Rasutrip Websoft Technologies LLP. All Rights Reserved.
          </p>
          <div className="flex items-center gap-3">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                className="h-8 w-8 rounded-full bg-white/5 flex items-center justify-center text-ink-400 hover:bg-brand-600 hover:text-white transition"
              >
                <s.icon size={13} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
